import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import useNameStyle from './useNameStyle'

function useDonationName(donation) {
  const donationId = useSelector(
    state => state.event.donationIds[donation.user_id]
  )
  const styledName = useNameStyle(donation.user_name)
  return useMemo(() => {
    if (styledName === 'paddle_number') {
      if (donation.user_phone) {
        return donation.user_phone.substr(donation.user_phone.length - 4)
      } else {
        return 'Anonymous'
      }
    } else {
      return styledName
    }
  }, [styledName])
}

export default useDonationName



// WEBPACK FOOTER //
// ./src/hooks/useDonationName.js